<template>
  <b-container fluid
               class="px-3">
    <esg-base-card title="LCA 공정별 배출량"
                   :footer="false">
      <template #actions>
        <b-row align-h="end"
               class="flex-fill">
          <b-col>
            <b-input-group>
              <b-form-input placeholder="제품군을 선택해주세요"
                            readonly
                            v-model="productFamily.name"
                            v-b-modal.product-family-search/>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- Product family search form -->
      </template>

      <!-- Main -->
      <!-- No data -->
      <div v-if="thereIsNoData"
           class="d-flex align-items-center justify-content-center"
           style="height: 500px">
        <span style="font-size: 1.125rem; font-family: NanumGothic">제품 생애주기 온실가스 배출량 조회를 위해 제품군을 선택해주세요.</span>
      </div>
      <!-- No data -->

      <!-- 공정별 -->
      <esg-base-dashboard-card v-show="productFamily.code"
                               :title="`${productFamily.name} 제품군`">
        <div class="content-title">전과정 온실가스 배출량 비율</div>
        <b-row align-h="center"
               align-v="center">
          <b-col>
            <ProductFamilyEmissionByLcaStage :product-family="productFamily"
                                             category="원료 획득"
                                             @noData="handleDataError"/>
          </b-col>
        </b-row>

        <div class="content-title">공정 온실가스 배출량 (상위 3개 제품)</div>
        <b-row class="mt-3"
               align-h="center"
               align-v="start">
          <template v-for="category in categories">
            <b-col sm="12"
                   md="6"
                   lg="4"
                   :key="category.value">
              <LcaEmissionByProduct :product-family="productFamily"
                                    :category="category"
                                    @noData="handleDataError"/>
            </b-col>
          </template>
        </b-row>
      </esg-base-dashboard-card>
      <!-- 공정별 -->
      <!-- Main -->

      <!-- Product family search modal -->
      <esg-base-dashboard-modal id="product-family-search"
                                size="lg"
                                title="제품군 선택">
        <esg-base-list name="esg_base_product_family"
                       @rowClicked="setProductFamily"/>
      </esg-base-dashboard-modal>
      <!-- /Product family search modal -->
    </esg-base-card>
  </b-container>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import ProductFamilyEmissionByLcaStage from "../../charts2/ProductFamilyEmissionByLcaStage.vue";
import LcaEmissionByProduct from "@/components/esg/3. Monitoring/charts2/LcaEmissionByProduct.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

export default {
  components: {
    EsgBaseDashboardModal, EsgBaseList,
    EsgBaseCard,
    ProductFamilyEmissionByLcaStage,
    LcaEmissionByProduct,
    EsgBaseDashboardCard,
  },
  computed: {
    thereIsNoData() {
      return !this.productFamily.code || !this.productFamily.name
    },
  },
  data() {
    return {
      productFamily: { code: null, name: null },
      categories: this.$store.getters['ghg/lifeCycleStages']
    }
  },
  methods: {
    setProductFamily(productFamily) {
      this.productFamily = productFamily
      this.$bvModal.hide('product-family-search')
    },
    async handleDataError() {
      this.productFamily = { code: null, name: null }
      await this.showError(new Error("데이터가 존재하지 않습니다."))
    },
  }
}
</script>

<style scoped>
/* 상단 상품 선택 */
.custom-select {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
  margin-bottom: 0;
}

.form-control[readonly] {
  background-color: #F6F6FA;
}

.form-control:focus {
  box-shadow: none;
  border-color: unset;
}

.content-title {
  font-weight: 600;
  margin-left: 1rem;
}
</style>